import type { ReactNode } from 'react'
import { useState } from 'react'
import type { CompositionContextValue } from '@joyful/utils'
import { createNonNullableContext } from '@joyful/utils'
import { useAnnouncementsMenuHint } from './hooks/useAnnouncementsMenuHint'

interface AnnouncementsMenuHintState {
  dismissedAt: string | null
  isHintVisible: boolean
}

interface AnnouncementsMenuHintActions {
  activateHint: () => void
  dismissHint: () => void
}

export type AnnouncementsMenuHintContextValue = CompositionContextValue<
  AnnouncementsMenuHintState,
  AnnouncementsMenuHintActions
>

const AnnouncementsMenuHintContext =
  createNonNullableContext<AnnouncementsMenuHintContextValue>(
    'AnnouncementsMenuHintContext',
  )

export const useAnnouncementsMenuHintContext =
  AnnouncementsMenuHintContext.useRequiredContext

export interface AnnouncementsMenuHintProviderProps {
  children: ReactNode
}

export function AnnouncementsMenuHintProvider({
  children,
}: AnnouncementsMenuHintProviderProps) {
  const { dismiss, dismissedAt } = useAnnouncementsMenuHint()
  const [isHintActive, setIsHintActive] = useState(false)

  const activateHint = () => {
    setIsHintActive(true)
  }

  const dismissHint = () => {
    setIsHintActive(false)
    dismiss()
  }

  const isHintVisible = isHintActive && dismissedAt === null

  return (
    <AnnouncementsMenuHintContext.Context
      value={{
        actions: {
          activateHint,
          dismissHint,
        },
        state: {
          dismissedAt,
          isHintVisible,
        },
      }}
    >
      {children}
    </AnnouncementsMenuHintContext.Context>
  )
}
